import { render, staticRenderFns } from "./CartBar.vue?vue&type=template&id=56762878"
import script from "./CartBar.vue?vue&type=script&lang=js"
export * from "./CartBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports